import { render, staticRenderFns } from "./ColumnView.vue?vue&type=template&id=3631d1a2&scoped=true"
import script from "./ColumnView.vue?vue&type=script&lang=js"
export * from "./ColumnView.vue?vue&type=script&lang=js"
import style0 from "./ColumnView.vue?vue&type=style&index=0&id=3631d1a2&prod&scoped=true&lang=css"
import style1 from "./ColumnView.vue?vue&type=style&index=1&id=3631d1a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3631d1a2",
  null
  
)

export default component.exports